import React from 'react';
import { colors } from 'helpers/ColorHelper';
import gridStyles from 'components/landlord_app/insights/components/reporting/gridStyles.css';
import { toFriendlyDateString, toFriendlyDateTimeString, formatMoney } from 'helpers/Formatter';

function columnWidths(reportType, width = null, columnCount = null) {
  // Add the column widths and text allign into an object
  // format: {[columnWidth, textAlign], [..], ...}
  if (reportType === 'vacancy_report') {
    return {
      0: [100, 'left'],
      1: [225, 'left'],
      2: [150, 'left'],
      3: [150, 'left'],
      4: [125, 'left'],
      5: [150, 'left'],
      6: [125, 'left'],
      7: [150, 'left'],
    };
  }

  if (reportType === 'rent_roll') {
    return {
      0: [65, 'left'],
      1: [250, 'left'],
      2: [275, 'left'],
      3: [200, 'left'],
      4: [300, 'left'],
      5: [125, 'left'],
      6: [150, 'left'],
      7: [125, 'left'],
      8: [150, 'left'],
      9: [125, 'left'],
      10: [125, 'left'],
      11: [75, 'left'],
      12: [75, 'left'],
    };
  }

  if (reportType === 'applications') {
    return {
      0: [100, 'left'],
      1: [250, 'left'],
      2: [250, 'left'],
      3: [100, 'left'],
      4: [300, 'left'],
      5: [125, 'left'],
      6: [150, 'left'],
      7: [100, 'left'],
      8: [350, 'left'],
      9: [150, 'left'],
      10: [100, 'left'],
      11: [300, 'left'],
      12: [300, 'left'],
    };
  }

  if (['showings_by_booked_date', 'showings_by_showing_date'].includes(reportType)) {
    return {
      0: [125, 'left'],
      1: [125, 'left'],
      2: [125, 'left'],
      3: [150, 'left'],
      4: [150, 'left'],
      5: [150, 'left'],
      6: [150, 'left'],
      7: [300, 'left'],
      8: [150, 'left'],
      9: [150, 'left'],
      10: [125, 'left'],
      11: [125, 'left'],
      12: [125, 'left'],
      13: [125, 'left'],
      14: [125, 'left'],
      15: [300, 'left'],
      16: [300, 'left'],
    };
  }

  if (reportType === 'leases') {
    return {
      0: [125, 'left'],
      1: [150, 'left'],
      2: [150, 'left'],
      3: [150, 'left'],
      4: [300, 'left'],
      5: [150, 'left'],
      6: [150, 'left'],
      7: [150, 'left'],
      8: [125, 'left'],
      9: [125, 'left'],
      10: [300, 'left'],
      11: [400, 'left'],
      12: [400, 'left'],
    };
  }

  if (reportType === 'deposits_report') {
    return {
      0: [250, 'left'],
      1: [100, 'left'],
      2: [300, 'left'],
      3: [150, 'left'],
      4: [150, 'left'],
      5: [175, 'left'],
      6: [150, 'left'],
    };
  }

  if (reportType === 'payments_report') {
    return {
      0: [65, 'left'],
      1: [150, 'left'],
      2: [150, 'left'],
      3: [150, 'left'],
      4: [150, 'left'],
      5: [175, 'left'],
      6: [150, 'left'],
      7: [100, 'left'],
      8: [75, 'left'],
      9: [75, 'left'],
      10: [75, 'left'],
    };
  }

  if (reportType === 'ancillary_items') {
    return {
      0: [150, 'left'],
      1: [125, 'left'],
      2: [125, 'left'],
      3: [150, 'left'],
      4: [150, 'left'],
      5: [150, 'left'],
      6: [175, 'left'],
      7: [150, 'left'],
      8: [150, 'left'],
      9: [150, 'left'],
      10: [150, 'left'],
      11: [150, 'left'],
    };
  }

  if (reportType === 'maintenance_tickets') {
    return {
      0: [75, 'left'],
      1: [150, 'left'],
      2: [150, 'left'],
      3: [250, 'left'],
      4: [250, 'left'],
      5: [150, 'left'],
      6: [175, 'left'],
      7: [150, 'left'],
      8: [150, 'left'],
      9: [150, 'left'],
      10: [175, 'left'],
      11: [175, 'left'],
      12: [175, 'left'],
      13: [175, 'left'],
      14: [175, 'left'],
      15: [250, 'left'],
    };
  }

  if (reportType === 'maintenance_log') {
    return {
      0: [75, 'left'],
      1: [150, 'left'],
      2: [150, 'left'],
      3: [250, 'left'],
      4: [150, 'left'],
      5: [175, 'left'],
      6: [150, 'left'],
      7: [150, 'left'],
      8: [150, 'left'],
      9: [150, 'left'],
      10: [175, 'left'],
      11: [175, 'left'],
      12: [175, 'left'],
      13: [175, 'left'],
      14: [250, 'left'],
      15: [250, 'left'],
    };
  }

  if (reportType === 'capreit_tenant_name_change_report') {
    return {
      0: [175, 'left'],
      1: [175, 'left'],
      2: [175, 'left'],
      3: [175, 'left'],
      4: [175, 'left'],
      5: [175, 'left'],
      6: [100, 'left'],
      7: [200, 'left'],
      8: [200, 'left'],
      9: [200, 'left'],
      10: [200, 'left'],
      11: [150, 'left'],
    };
  }

  if (reportType === 'lead_marketing_report') {
    return {
      0: [150, 'left'],
      1: [200, 'left'],
      2: [200, 'left'],
      3: [175, 'left'],
      4: [225, 'left'],
      5: [250, 'left'],
    };
  }

  if (reportType === 'resident_data_report') {
    return {
      0: [200, 'left'],
      1: [150, 'left'],
      2: [80, 'left'],
      3: [200, 'left'],
      4: [150, 'left'],
      5: [200, 'left'],
      6: [150, 'left'],
      7: [100, 'left'],
    };
  }

  if (reportType === 'prospect_data_report') {
    return {
      0: [125, 'left'],
      1: [175, 'left'],
      2: [200, 'left'],
      3: [200, 'left'],
      4: [150, 'left'],
      5: [150, 'left'],
      6: [150, 'left'],
      7: [150, 'left'],
      8: [200, 'left'],
      9: [225, 'left'],
      10: [150, 'left'],
      11: [125, 'left'],
      12: [150, 'left'],
      13: [200, 'left'],
    };
  }

  if (reportType === 'detailed_resident_data_report') {
    return {
      0: [200, 'left'],
      1: [80, 'left'],
      2: [200, 'left'],
      3: [100, 'left'],
      4: [80, 'left'],
      5: [100, 'center'],
      6: [100, 'center'],
      7: [200, 'center'],
      8: [200, 'center'],
      9: [200, 'center'],
      10: [100, 'left'],
      11: [100, 'left'],
      12: [100, 'left'],
    };
  }
  if (reportType === 'maintenance_work_log') {
    return {
      0: [200, 'left'],
      1: [200, 'left'],
      2: [200, 'left'],
      3: [200, 'left'],
      4: [500, 'left'],
      5: [100, 'left'],
      6: [100, 'left'],
    };
  }

  // TODO: return null here and check for that instead.
  return {
    0: [width / columnCount, 'left'],
    1: [width / columnCount, 'left'],
    2: [width / columnCount, 'left'],
    3: [width / columnCount, 'left'],
    4: [width / columnCount, 'left'],
    5: [width / columnCount, 'left'],
    6: [width / columnCount, 'left'],
    7: [width / columnCount, 'left'],
    8: [width / columnCount, 'left'],
    9: [width / columnCount, 'left'],
    10: [width / columnCount, 'left'],
  };
}

function columnTextAlign(columnIndex, reportType) {
  // Add your text align functions for each report type here.
  if (reportType !== 'balance_sheet' && reportType !== 'profit_loss') {
    return columnWidths(reportType)[columnIndex][1];
  }

  return columnIndex > 0 ? 'right' : 'left';
}

export function fixedColumns(reportType) {
  let fixedColumns = 0;

  if (reportType === 'balance_sheet' || reportType === 'profit_loss') {
    fixedColumns = 1;
  }

  return fixedColumns;
}

export function fixedRows(reportType) {
  let fixedRows = 1;

  if (reportType === 'balance_sheet' || reportType === 'profit_loss') {
    fixedRows = 2;
  }

  return fixedRows;
}

export function getColumnWidthHelper(width, reportType, columnCount) {
  return ({ index }) => {
    const minWidth = (columnCount - 1) * 125 + 300;

    if (
      reportType === 'general_ledger' ||
      reportType === 'aged_receivables' ||
      reportType === 'aged_payables' ||
      reportType === 'all_transactions' ||
      reportType === 'general_journal' ||
      reportType === 'vacancy_report' ||
      reportType === 'rent_roll' ||
      reportType === 'applications' ||
      reportType === 'showings' ||
      reportType === 'showings_by_booked_date' ||
      reportType === 'showings_by_showing_date' ||
      reportType === 'capreit_tenant_name_change_report' ||
      reportType === 'leases' ||
      reportType === 'payments_report' ||
      reportType === 'deposits_report' ||
      reportType === 'ancillary_items' ||
      reportType === 'maintenance_tickets' ||
      reportType === 'maintenance_log' ||
      reportType === 'resident_data_report' ||
      reportType === 'prospect_data_report' ||
      reportType === 'lead_marketing_report' ||
      reportType === 'detailed_resident_data_report' ||
      reportType === 'maintenance_work_log'
    ) {
      return columnWidths(reportType, width, columnCount)[index][0];
    }

    if (reportType === 'balance_sheet' || reportType === 'profit_loss') {
      return index === 0 ? 300 : (Math.max(minWidth, width) - 300) / (columnCount - 1);
    }

    return minWidth;
  };
}

const smartFormatter = objectToFormat => {
  if (objectToFormat.isMoney) {
    return formatMoney(objectToFormat.value);
  }
  if (objectToFormat.isDate) {
    return toFriendlyDateString(objectToFormat.value);
  }
  if (objectToFormat.isDateTime) {
    return toFriendlyDateTimeString(objectToFormat.value);
  }
  return objectToFormat.value;
};

export function columnCount(data) {
  let columnCount = 0;
  if (data.length > 0) {
    columnCount = data[0].length;
  }

  return columnCount;
}

export function cellRenderer({ columnIndex, key, rowIndex, style }, data, reportType) {
  const rowCount = data.length;

  if (rowCount === 0 || columnCount(data) === 0) {
    return null;
  }

  // this adds an expandable icon to the cell if it is a title, and its the first of its grouping
  if (
    rowIndex < rowCount - 1 &&
    data[rowIndex + 1][columnIndex].grouping !== data[rowIndex][columnIndex].grouping &&
    data[rowIndex + 1][columnIndex].grouping === data[rowIndex][columnIndex].value &&
    data[rowIndex][columnIndex].isTitle &&
    data[rowIndex][columnIndex].expandable
  ) {
    data[rowIndex][columnIndex].groupTab = '[-]   ';
  }

  // this adds a tabbed space to the cell if it is a title, and its the second of its grouping
  if (
    rowIndex > 0 &&
    data[rowIndex - 1][columnIndex].groupTab === '[-]   ' &&
    data[rowIndex][columnIndex].isTitle
  ) {
    data[rowIndex][columnIndex].groupSpace = data[rowIndex - 1][columnIndex].groupSpace + '      ';
  }

  // this retains the cell in the row above's formatting if it is not a title and in the same grouping
  if (
    rowIndex > 0 &&
    data[rowIndex - 1][columnIndex].groupTab !== '[-]   ' &&
    data[rowIndex][columnIndex].isTitle &&
    data[rowIndex - 1][columnIndex].groupSpace !== '' &&
    data[rowIndex - 1][columnIndex].grouping === data[rowIndex][columnIndex].grouping
  ) {
    data[rowIndex][columnIndex].groupSpace = data[rowIndex - 1][columnIndex].groupSpace;
  }

  // this removes the tabbing of the cell in the row above's formatting if it is not a title and not in the same grouping
  if (
    rowIndex > 2 &&
    data[rowIndex][columnIndex].groupTab === '[-]   ' &&
    data[rowIndex - 1][columnIndex].grouping === data[rowIndex - 2][columnIndex].grouping &&
    data[rowIndex - 1][columnIndex].grouping !== data[rowIndex][columnIndex].grouping
  ) {
    data[rowIndex][columnIndex].groupSpace = data[rowIndex - 1][columnIndex].groupSpace.replace(
      '      ',
      ''
    );
  }

  // bolds the header (ie the first row)
  if (rowIndex > 0 && data[rowIndex][columnIndex].isBolded) {
    data[rowIndex][columnIndex].groupSpace = '';
  }

  return (
    <div className={gridStyles.Cell} key={key} style={style}>
      {data[rowIndex][columnIndex].isTitle &&
        !data[rowIndex][columnIndex].isHeader && (
          <p
            style={{
              fontFamily: data[rowIndex][columnIndex].isBolded ? 'Circular-Black' : 'Circular',
              borderBottomStyle: data[rowIndex][columnIndex].isUnderlined ? 'double' : '',
              textAlign: columnTextAlign(columnIndex, reportType),
              margin: 0,
              whiteSpace: 'pre-wrap',
            }}
          >
            {data[rowIndex][columnIndex].groupSpace +
              data[rowIndex][columnIndex].groupTab +
              smartFormatter(data[rowIndex][columnIndex])}
          </p>
        )}
      {!data[rowIndex][columnIndex].isTitle &&
        !data[rowIndex][columnIndex].isHeader && (
          <p
            style={{
              fontFamily: data[rowIndex][columnIndex].isBolded ? 'Circular-Black' : 'Circular',
              borderBottomStyle: data[rowIndex][columnIndex].isUnderlined ? 'double' : '',
              textAlign: columnTextAlign(columnIndex, reportType),
              margin: 0,
              overflow: data[rowIndex][columnIndex].isBolded ? 'inherit' : 'hidden',
              textOverflow: data[rowIndex][columnIndex].isBolded ? 'inherit' : 'ellipsis',
              whiteSpace: data[rowIndex][columnIndex].isBolded ? 'inherit' : 'nowrap',
            }}
          >
            {data[rowIndex][columnIndex].isClickable && (
              <button type="button" className="link-button" style={{ color: colors.DARK_GRAY }}>
                {smartFormatter(data[rowIndex][columnIndex])}
              </button>
            )}
            {!data[rowIndex][columnIndex].isClickable && (
              <span>{smartFormatter(data[rowIndex][columnIndex])}</span>
            )}
          </p>
        )}
      {data[rowIndex][columnIndex].isHeader && (
        <p
          style={{
            fontFamily: 'Circular-Black',
            textAlign: columnTextAlign(columnIndex, reportType),
            margin: 0,
          }}
        >
          {smartFormatter(data[rowIndex][columnIndex])}
        </p>
      )}
    </div>
  );
}
